<template>
    <div class="cp-hp-project-slider">
        <div class="teq-container">
            <mobile-hp-project-slider v-if="mobileVersion" :slides="projectSlider"></mobile-hp-project-slider>
            <desktop-hp-project-slider v-else :slides="projectSlider" ></desktop-hp-project-slider>
        </div>
    </div>
</template>

<script>
    import mobileVersion from '../../mixins/mobileVersion';
    import MobileHpProjectSlider from './MobileHpProjectSlider';
    import DesktopHpProjectSlider from './DesktopHpProjectSlider';

    export default {
        components: {
            MobileHpProjectSlider,
            DesktopHpProjectSlider,
        },
        mixins: [
            mobileVersion,
        ],
        props: {
            projectSlider: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                widthLimit: 768
            }
        },
    }
</script>
  